import { ApiContext } from '../../types'
import {
  deserializeAudio,
  deserializeSegment,
} from '@/api_client/api/serializers/audio'
import { AuthHelper } from '@/api_client'
import { Folder } from '@/api_client/types/folders'
import { deserializeFolder } from '@/api_client/api/serializers/folder'

export default async function updateFolder(
  { client, config }: ApiContext,
  audioId,
  data,
): Promise<Folder> {
  try {
    const bearerToken = AuthHelper.getAccessToken()
    const result = await client.folders.update(
      bearerToken.toString(),
      audioId,
      data,
    )

    if (result.isSuccess()) {
      const payload = result.success()
      console.log(payload)
      return deserializeFolder(payload)
    } else {
      throw result.fail()
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
